import { Defined } from './defined.js';
import { isNeitherNullNorUndefined } from './guard.js';
class Optional {
    value;
    constructor(value) {
        this.value = value;
    }
    static some = (value) => {
        if (isNeitherNullNorUndefined(value)) {
            return new Optional(value);
        }
        throw new Error('value is null or undefined');
    };
    static none = () => {
        return new Optional(undefined);
    };
    static from = (value) => {
        return isNeitherNullNorUndefined(value)
            ? Optional.some(value)
            : Optional.none();
    };
    isSome = () => {
        return isNeitherNullNorUndefined(this.value);
    };
    isNone = () => {
        return !this.isSome();
    };
    match = (props) => {
        return this.isSome()
            ? props.some(this.unwrapOrThrow('value is null or undefined'))
            : props.none();
    };
    map = (fn) => {
        if (this.isSome()) {
            return new Optional(fn(this.value));
        }
        return new Optional(undefined);
    };
    flatMap = (fn) => {
        if (this.isSome()) {
            return fn(this.value);
        }
        return new Optional(undefined);
    };
    ifSome = (fn) => {
        if (this.isSome()) {
            fn(this.unwrapOrThrow('value is null or undefined'));
        }
    };
    ifNone = (fn) => {
        if (this.isNone()) {
            fn();
        }
    };
    unwrapOrGet = (t) => {
        return Defined.parse(this.value).orGet(t);
    };
    unwrapOrElse = (fn) => {
        return Defined.parse(this.value).orElse(fn);
    };
    unwrapOrThrow = (error) => {
        return Defined.parse(this.value).orThrow(error);
    };
}
export { Optional };
//# sourceMappingURL=optional.js.map